import { H2RSelect } from "../../imports";
import { patternTypesDefinitions } from "../../imports";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<H2RSelect
				selected={cue.pattern || "p1"}
				label="Pattern"
				options={[
					...Object.entries(patternTypesDefinitions).map(([p, n]) => {
						return {
							label: n.name,
							value: p,
						};
					}),
				]}
				onChange={(value) => {
					return onUpdate({ pattern: value });
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">
				{patternTypesDefinitions[cue.pattern]?.name || "Pattern"}
			</span>
		</div>
	);
};
